<template>
  <div class="error404 404.vue yellowjob">

    <div class="content">

      <div class="sauron">
        <icon404></icon404>
        <div class="buld">
          <div class="limit">
            <div class="iris"></div>
          </div>

        </div>
        <!-- /.buld -->
      </div>
      <!-- /.sauron -->

      <div class="help">
        <h1>oxe!</h1>
        Não encontramos a sua página, mas <a @click="goHome()" href="#">clique aqui</a> pra voltar para home


        <a href="javascript:;" class="go-back" @click="goHome()">
          <arrowBack></arrowBack>
        </a>

      </div>
      <!-- /.help -->

    </div>

  </div>
</template>

<script>
  import arrowBack from './arrowBack.vue'
  import icon404 from '../assets/404.svg'
  import vivus from 'vivus'

export default {
  name: 'Error404',
  data () {
    return {
      delay: 1000,
      anim:{}
    }
  },
  components:{
    arrowBack,
    icon404
  },
  beforeDestroy(){
    $(document).off('mousemove');
    this.anim.stop().destroy();
  },
  methods:{
    goHome(){
      this.$router.push('/');
    }
  },
  mounted(){
    // seta a classe do menu principal
    this.$store.commit('setMenuClass', 'inverted');

    let anim = new vivus(document.querySelector('.icon404'), {
      start: 'manual', // avoid memory leak o scroll event
      duration: 20,
      animTimingFunction: vivus.EASE_IN,
    });

    this.anim = anim;
    anim.reset().stop();
    this.timeoutPointer = setTimeout(() => {
      try {
        anim.play();
      } catch (e) {
      }
    }, this.delay);

    $(document).mousemove(function(event) {
      let eye = $(".buld");
      let x = (eye.offset().left) + (eye.width() / 2);
      let y = (eye.offset().top) + (eye.height() / 2);
      let rad = Math.atan2(event.pageX - x, event.pageY - y);
      let rot = (rad * (180 / Math.PI) * -1) + 180;
      eye.css({
        '-webkit-transform': 'rotate(' + rot + 'deg)',
        '-moz-transform': 'rotate(' + rot + 'deg)',
        '-ms-transform': 'rotate(' + rot + 'deg)',
        'transform': 'rotate(' + rot + 'deg)'
      });
    });

  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Error404.vue